export default __webpack_public_path__ + "static/media/juegos2024.a5867741.pdf";